import { CalendarMultipleIcon } from './CalendarMultipleIcon';

/**
 * author: Austin Andrews
 * id F4851A5B-6F19-4C18-9A13-4BF2617FF0E0
 * name calendar-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-multiple.svg
 * tags
 * - Date / Time 
 */
export const EventsIcon = CalendarMultipleIcon;
export default EventsIcon